import React from 'react';

export default ({address})=> (
	<address className='AddressCompact'>
		{address.attentionName ? <div>Attn: {address.attentionName}</div> : null}
		<div>{address.addressee}</div>
		<div>{address.addressOne}</div>
		<div>{address.city}, {address.state} {address.postalCode}</div>
	</address>
);